<div class="professional-immersion-experience" *ngIf="professionalImmersionExperience || loading()">
  <lx-card-container
    type="professional-immersion-experience"
    i18n-title
    title="Professional Immersion Experience"
    [loading]="loading()"
    [actionMode]="selectedProfessionalImmersionExperienceCode ? 'remove' : 'add'"
    [endPrice]="endPrice"
    [price]="price"
    [currency]="currency?.()"
    [discount]="discount"
    [disabled]="!!!selectedProfessionalImmersionExperienceCode"
    (buttonClick)="toggleProfessionalImmersionExperience(professionalImmersionExperience?.code)"
    [gaEventName]="dataLayerEventName$ | async"
    [attr.data-qa]="'professionalImmersionExperience_header'"
  >
    <div class="professional-immersion-experience__paragraph" i18n>Improve your language skills + gain real work experience abroad.</div>
  </lx-card-container>
</div>
